import React from 'react'
import { Button } from 'reactstrap'
import Icon from '@/components/Icon'
import Resx from '@/components/Resx'

export default (props) => <Button color='danger' {...props}><Icon name='error' /> <Resx name='Common.ErrorOccurredRetry' /></Button>



// WEBPACK FOOTER //
// ./src/components/ErrorButton.js